(function () {
	function initMigrationPricing() {
		document.querySelectorAll('.block-migration-pricing').forEach(function (block) {
			var buttons = Array.from(block.querySelectorAll('[data-migration-pricing-tab-button]'));
			var panelsWrapper = block.querySelector('.block-migration-pricing__panels');
			var panels = panelsWrapper ? Array.from(panelsWrapper.querySelectorAll('[data-migration-pricing-panel]')) : [];

			if (!buttons.length || !panels.length) {
				return;
			}

			function setActive(index) {
				buttons.forEach(function (button, buttonIndex) {
					var isActive = buttonIndex === index;
					button.classList.toggle('is-active', isActive);
					button.setAttribute('aria-selected', isActive ? 'true' : 'false');
				});

				panels.forEach(function (panel, panelIndex) {
					var isActive = panelIndex === index;
					panel.classList.toggle('is-active', isActive);
					panel.setAttribute('data-tab-visible', isActive ? 'true' : 'false');
				});

				panelsWrapper.classList.add('has-active-panel');
			}

			buttons.forEach(function (button, index) {
				button.addEventListener('click', function () {
					setActive(index);
				});
			});

			setActive(0);
		});
	}

	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		setTimeout(initMigrationPricing, 1);
	} else {
		document.addEventListener('DOMContentLoaded', initMigrationPricing);
	}
})();
